export class SIQInfoMessageTheme {
  textColor = "null";
  lineColor = "null";
}
//# sourceMappingURL=SIQInfoMessageTheme.js.map